module.exports = __webpack_public_path__ + "static/media/view1.5f6288c1.jpg";